import React from 'react';
import { FiSearch } from 'react-icons/fi';

import styles from './logstyles.module.scss';

interface InfoRowProps {
  label: string;
  value?: string | number | null;
  mono?: boolean;
  /** When set, render a magnifying-glass icon that opens this URL in a new tab,
   *  filtering /logs by just this field. The icon is hidden when value is empty. */
  filterHref?: string;
}

const InfoRow = ( { label, value, mono = false, filterHref }: InfoRowProps ) => {
  const showFilter = !!filterHref && value !== null && value !== undefined && value !== '';
  return (
    <div className={ styles.infoRow }>
      <span className={ styles.infoLabel }>{label}</span>
      <span className={ mono ? styles.infoValueMono : styles.infoValue }>
        {value ?? <span className={ styles.nullValue }>null</span>}
      </span>
      {showFilter && (
        <a
          className={ styles.filterAction }
          href={ filterHref }
          target="_blank"
          rel="noopener noreferrer"
          title={ `Open /logs filtered by ${ label }` }
          aria-label={ `Open /logs filtered by ${ label }` }
        >
          <FiSearch size={ 14 } />
        </a>
      )}
    </div>
  );
};

export default InfoRow;
